// extracted by mini-css-extract-plugin
export default {"progress":"InputProgress_progress__024ld","input-progress":"InputProgress_input-progress__dbMTq"};